import React from 'react';
import { ORDERS_QUEUES } from '@app/reducer/orders';
import { Tabs, Tab } from 'material-ui/Tabs';

const styles = {
  container: {
    backgroundColor: '#4a4a4a',
  },
  inkBarStyle: {
    height: 4,
  },
  tab: {
    buttonStyle: {
      fontSize: 16,
      color: 'white',
    },
  },
};

const OrdersTabs = React.memo(({ selectedOrderQueue, switchOrderQueueView }) => {
  return (
    <Tabs
      value={selectedOrderQueue}
      onChange={value => switchOrderQueueView(value)}
      inkBarStyle={styles.inkBarStyle}
      tabItemContainerStyle={styles.container}
    >
      <Tab
        value={ORDERS_QUEUES.INCOMING}
        buttonStyle={styles.tab.buttonStyle}
        label="Novos Pedidos"
      ></Tab>
      <Tab
        value={ORDERS_QUEUES.BEING_DELIVERED}
        buttonStyle={styles.tab.buttonStyle}
        label="Pedidos em andamento"
      ></Tab>
      <Tab
        buttonStyle={styles.tab.buttonStyle}
        value={ORDERS_QUEUES.FINALIZED}
        label="Pedidos Concluidos"
      ></Tab>
    </Tabs>
  );
});

export default OrdersTabs;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrdersLayout/OrdersTabs.jsx